import type { ReactNode } from 'react';
import { CloseButton } from '../CloseButton';
import { useDetailPanelSafe } from './DetailPanelContext';
import { ChevronLeftIcon } from '../icons';
import { useListingName } from '../../../hooks/useListingName';
import * as styles from './detailPanel.styles';

type DetailPanelHeaderProps = {
  onClose: () => void;
  actions?: ReactNode;
  closeLabel?: string;
  subtitle?: string;
};

export const DetailPanelHeader = ({ onClose, actions, closeLabel, subtitle }: DetailPanelHeaderProps) => {
  const panelContext = useDetailPanelSafe();
  const configTitle = (panelContext?.panelConfig as { title?: string } | undefined)?.title;
  const listingName = useListingName();
  const propertyName = configTitle || listingName;

  return (
    <header className={styles.panelHeader}>
      <div className={styles.panelHeaderColumns}>
        <div className={styles.panelHeaderLeft}>
          {closeLabel ? (
            <button className={styles.panelBackButton} onClick={onClose} aria-label={closeLabel}>
              <ChevronLeftIcon />
              <span>{closeLabel}</span>
            </button>
          ) : (
            <CloseButton onClick={onClose} aria-label="Close panel" size="sm" />
          )}
          <div>
            <h2 className={styles.panelHeaderTitle}>{propertyName}</h2>
            {subtitle && <p className={styles.panelHeaderSubtitle}>{subtitle}</p>}
          </div>
        </div>
        <div className={styles.panelHeaderRight}>{actions}</div>
      </div>
    </header>
  );
};
